import { useQuery } from "@tanstack/react-query";

import { WORKER_URL } from "../prospects/enrichFromSource";
import type { AuctionsResponse, ProbatesResponse } from "./types";

const fetchJson = async <T>(path: string): Promise<T> => {
  const res = await fetch(`${WORKER_URL}${path}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Worker ${res.status} ${text.slice(0, 120)}`);
  }
  return res.json();
};

const STALE_TIME = 5 * 60 * 1000;

/** All auction leads from the comps-proxy Worker (normalized Airtable rows). */
export const useAuctions = () =>
  useQuery({
    queryKey: ["deals", "auctions"],
    queryFn: () => fetchJson<AuctionsResponse>("/auctions"),
    staleTime: STALE_TIME,
    select: (data) => data.auctions ?? [],
  });

/** All probate leads. Most lack lat/lng until geocoded client-side. */
export const useProbates = () =>
  useQuery({
    queryKey: ["deals", "probates"],
    queryFn: () => fetchJson<ProbatesResponse>("/probates"),
    staleTime: STALE_TIME,
    select: (data) => data.probates ?? [],
  });
